export const FlareMadCapXMLNSName: string = 'xmlns:MadCap';
export const FlareMadCapXMLNSValue: string = 'http://www.madcapsoftware.com/Schemas/MadCap.xsd';
export const FlareMadCapXMLNSAttribute: string = `${FlareMadCapXMLNSName}="${FlareMadCapXMLNSValue}"`;
